import { render, staticRenderFns } from "./PT610FirstAccessMenberInfoParts.vue?vue&type=template&id=423baa12&"
import script from "./PT610FirstAccessMenberInfoParts.vue?vue&type=script&lang=js&"
export * from "./PT610FirstAccessMenberInfoParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports